import React, { useMemo } from 'react';
import _ from 'lodash'
import { NavigationContainer } from '@react-navigation/native';
import { AppRoutes } from "navigations/app-routes";
import i18n from "utils/i18n";
import { navigationContainerProps } from 'utils/helper-navigation-container'
import { stackProps } from 'utils/helper-navigation'
import HomeTabsNavigator from 'navigations/home/tabs'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import HomeHomeIndexScene from 'scenes/home/home'
import HomeQrCodeScanScene from 'scenes/home/qrcode/scan'
import HomeQrCodeValidateBookingScene from 'scenes/home/qrcode/validate_booking'
import HomePresenceTransportScene from 'scenes/home/presence/transport'
import HomeMoreProfileScene from 'scenes/home/more/profile'
import HomeBookEvents from 'scenes/home/book/events'
import HomeBookEventsView from 'scenes/home/book/events/view'
import HomeCoworkerIndexScene from 'scenes/home/coworker/index'
import HomeCoworkerViewScene from 'scenes/home/coworker/view'
import HomeCoworkerViewEroScene from 'scenes/home/coworker/view/ero'
import HomeCoworkerViewConfidantScene from 'scenes/home/coworker/view/confidant'
import HomeCoworkerFilterSelectionScene from 'scenes/home/coworker/filter/selection'
import HomeCoworkerFilterResultsScene from 'scenes/home/coworker/filter/results'
import HomeMoreSettingsScene from 'scenes/home/more/settings'
import HomeMoreAboutScene from 'scenes/home/more/about'
import HomeMoreWorkdaysScene from 'scenes/home/more/workdays'
import HomeMoreTravelHistoryScene from 'scenes/home/more/travel_history'
import HomeMoreTravelHistoryDetailScene from 'scenes/home/more/travel_history/detail'
import HomeMoreTravelHistoryProfileEditScene from 'scenes/home/more/travel_history/profile_edit'
import HomeMoreAboutCalendarSubscription from 'scenes/home/more/calendar/subscription'
import HomeMorePrivacyScene from 'scenes/home/more/privacy'
import HomeMoreDebugScene from 'scenes/home/more/debug'
import HomeMoreDebugIconsScene from 'scenes/home/more/debug/icons'
import HomeMoreAccounts from 'scenes/home/more/accounts'
import HomeMoreInboxScene from 'scenes/home/more/inbox'
import HomeMoreInboxViewScene from 'scenes/home/more/inbox/view'
import HomeMoreCreditsScene from 'scenes/home/more/credits'
import HomeMoreCreditsBundleScene from 'scenes/home/more/credits/bundles/index'
import HomeInvitationSent from 'scenes/home/invitation/sent'
import HomeInvitationLogs from 'scenes/home/invitation/logs'
import HomeInvitationViewScene from 'scenes/home/invitation/received'
import HomeQrCodeTimeslotScene from 'scenes/home/qrcode/timeslot'
import HomeMoreIndexScene from 'scenes/home/more/index/index'
import HomeLunchScannerIndexScene from 'scenes/home/lunchScanner'
import HomeLunchSleepingIndexScene from 'scenes/home/lunchScanner/sleeping'
import HomeBookRoot from 'scenes/home/book'
import DebugVideo from 'scenes/home/more/debug/pages/video'
import HomeMoreCreditsViewScene from 'scenes/home/more/credits/view';
import HomeMoreCreditsItemViewScene from 'scenes/home/more/credits/item/view';
import HomeMoreCreditsBundlePaymentScene from 'scenes/home/more/credits/bundles/payment';
import HomeMoreCreditsTransactionsScene from 'scenes/home/more/credits/transactions';
import DesktopNavigationFrame from 'navigations/home/DesktopNavigationFrame';

const RootStack = createNativeStackNavigator();

const HomeNavigator = () => {
	
	const routes = {
		[ AppRoutes.TABS ] : HomeTabsNavigator,
		[ AppRoutes.TAB_TODAY ]: HomeHomeIndexScene,
		
		// QR-code (checkin)
		[ AppRoutes.QRCODE_SCAN ]: HomeQrCodeScanScene,
		[ AppRoutes.QRCODE_VALIDATE_BOOKING ]: HomeQrCodeValidateBookingScene,
		[ AppRoutes.QRCODE_TIMESLOT ]: HomeQrCodeTimeslotScene,
		[ AppRoutes.PRESENCE_TRANSPORT ]: HomePresenceTransportScene,
		
		// QR-code Lunch scanner
		[ AppRoutes.LUNCH_SCANNER ]: HomeLunchScannerIndexScene,
		[ AppRoutes.LUNCH_SLEEPING ]: HomeLunchSleepingIndexScene,
		
		// Booking
		[ AppRoutes.ADD_BOOKING ]: HomeBookRoot,
		//[ AppRoutes.ADD_BOOKING_OPTION ]: HomeBookStartScene,
		//[ AppRoutes.ADD_BOOKING_PREVIEW ]: HomeBookTimeslotPreviewScene,
		//[ AppRoutes.ADD_BOOKING_SELECT_COWORKER ]: HomeBookSelectCoworkerIndexScene,
		//[ AppRoutes.ADD_BOOKING_VIEW_COWORKER ]: HomeBookSelectCoworkerViewScene,
		//[ AppRoutes.ADD_BOOKING_LOCATION ]: HomeBookLocationScene,
		//[ AppRoutes.ADD_BOOKING_LOCATION_2 ]: HomeBookLocationScene,
		//[ AppRoutes.ADD_BOOKING_LOCATION_3 ]: HomeBookLocationScene,
		//[ AppRoutes.ADD_BOOKING_DATE ]: HomeBookTimeslotScene,
		//[ AppRoutes.ADD_BOOKING_LUNCH ]: HomeBookLunchScene,
		//[ AppRoutes.ADD_BOOKING_LICENSE_PLATE ]: HomeBookLicensePlateScene,
		//[ AppRoutes.ADD_BOOKING_OVERVIEW ]: HomeBookValidateScene,
		//[ AppRoutes.ADD_BOOKING_SUCCESS ]: HomeBookFinishedScene,
		
		// Invitation
		[ AppRoutes.INVITATION_RECEIVED ]: HomeInvitationViewScene,
		[ AppRoutes.INVITATION_SENT ]: HomeInvitationSent,
		[ AppRoutes.INVITATION_LOGS ]: HomeInvitationLogs,
		
		// Events
		[ AppRoutes.EVENTS ]: HomeBookEvents,
		[ AppRoutes.EVENT_VIEW ]: HomeBookEventsView,
		
		// Co workers
		[ AppRoutes.COWORKERS ]: HomeCoworkerIndexScene,
		[ AppRoutes.COWORKERS_VIEW ]: HomeCoworkerViewScene,
		[ AppRoutes.ERO_COWORKER ]: HomeCoworkerViewEroScene,
		[ AppRoutes.CONFIDANT_COWORKER ]: HomeCoworkerViewConfidantScene,
		[ AppRoutes.COWORKERS_FILTER_SELECTION ]: HomeCoworkerFilterSelectionScene,
		[ AppRoutes.COWORKERS_FILTER_RESULTS ]: HomeCoworkerFilterResultsScene,
		
		// More
		[ AppRoutes.MORE ]: HomeMoreIndexScene,
		[ AppRoutes.MORE_PROFILE ]: HomeMoreProfileScene,
		[ AppRoutes.MORE_SETTINGS ]: HomeMoreSettingsScene,
		[ AppRoutes.MORE_ABOUT ]: HomeMoreAboutScene,
		[ AppRoutes.MORE_WORKDAYS ]: HomeMoreWorkdaysScene,
		[ AppRoutes.MORE_TRAVEL_HISTORY ]: HomeMoreTravelHistoryScene,
		[ AppRoutes.MORE_TRAVEL_HISTORY_DETAIL ]: HomeMoreTravelHistoryDetailScene,
		[ AppRoutes.MORE_TRAVEL_HISTORY_PROFILE_EDIT ]: HomeMoreTravelHistoryProfileEditScene,
		[ AppRoutes.MORE_CALENDAR_SUBSCRIPTION ]: HomeMoreAboutCalendarSubscription,
		[ AppRoutes.MORE_PRIVACY ]: HomeMorePrivacyScene,
		[ AppRoutes.MORE_DEBUG ]: HomeMoreDebugScene,
		[ AppRoutes.MORE_DEBUG_INTERFACE_ICONS ]: HomeMoreDebugIconsScene,
		[ AppRoutes.MORE_DEBUG_VIDEO ]: DebugVideo,
		[ AppRoutes.MORE_ACCOUNTS ]: HomeMoreAccounts,
		[ AppRoutes.MORE_INBOX ]: HomeMoreInboxScene,
		[ AppRoutes.MORE_INBOX_VIEW ]: HomeMoreInboxViewScene,

		[ AppRoutes.MORE_CREDITS ]: HomeMoreCreditsScene,
		[ AppRoutes.MORE_CREDITS_VIEW ]: HomeMoreCreditsViewScene,
		[ AppRoutes.MORE_CREDITS_TRANSACTIONS ]: HomeMoreCreditsTransactionsScene,
		[ AppRoutes.MORE_CREDITS_ITEM_VIEW ]: HomeMoreCreditsItemViewScene,
		[ AppRoutes.MORE_CREDITS_BUY ]: HomeMoreCreditsBundleScene,
		[ AppRoutes.MORE_CREDITS_BUY_PAYMENT ]: HomeMoreCreditsBundlePaymentScene,
	}
	
	const mainScreens = useMemo( () => {
		const screens = {};
		_.forEach( routes, ( component, key ) => {
			const ScreenComponent = component;
			screens[ key ] = {
				title: i18n.t( `titles.${key}` ),
				component: key === AppRoutes.TABS ? ScreenComponent : props => {
					return (
						<DesktopNavigationFrame navigation={ props.navigation } route={ props.route }>
							<ScreenComponent { ...props } />
						</DesktopNavigationFrame>
					);
				},
			}
		});
		return screens;
	}, [] );
	
	return (
		<NavigationContainer
			{ ...navigationContainerProps }>
			
			<RootStack.Navigator
				{ ...stackProps }>
				
				{ _.map( mainScreens, ( screen, name ) => {
					return (
						<RootStack.Screen
							key={ `screen_${name}` }
							name={ name }
							component={ screen.component }
						/>
					);
				})}
			</RootStack.Navigator>
		</NavigationContainer>
	)
}

export default HomeNavigator
